import { ValidationError } from "sequelize"
import {
    RrsTemplateLabel,
    RrsTemplateLabelCreate,
    RrsTemplateLabelSave,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    RrsTemplateList,
    RrsTemplateLabelValidation,
} from "client/store"

export const LoadAllRrsTemplateLabels = (templateId: number) => (
    GET(`/rrsTemplateLabel/templateId/${templateId}`)
    .then((labels: RrsTemplateLabel[]) => labels)
)

export const LoadRrsTemplateLabelById = (labelId: number) => (
    GET(`/rrsTemplateLabel/id/${labelId}`)
    .then((label: RrsTemplateLabel) => label)
)

export const SelectParentRrsTemplateLabels = (categoryIds: number[]) => (
    POST(
        "/rrsTemplateLabel/selectParentTemplates",
        JSON.stringify(categoryIds),
    ).then((labels: RrsTemplateLabel[]) => {
        const templates: RrsTemplateList = {}
        labels.forEach((label) => {
            if (label.template) templates[label.template.id] = label.template
        })
        return templates
    })
)

export const SaveRrsTemplateLabel = (
    id: number,
    label: RrsTemplateLabelCreate,
    lang: LangType,
) => {
    const data: RrsTemplateLabelSave = {
        id,
        label,
    }
    return POST(
        "/rrsTemplateLabel/save",
        JSON.stringify(data),
    ).then((res) => {
        const newLabel = res as RrsTemplateLabel
        const error = res as ValidationError

        return {
            newLabelId: newLabel.id || null,
            validation: <RrsTemplateLabelValidation>validate(error, lang),
        }
    })
}

export const DeleteRrsTemplateLabel = (labelId: number) => (
    DELETE(`/rrsTemplateLabel/delete/${labelId}`)
    .then((removedRows: number) => removedRows)
)
